import { useLocation } from 'react-router-dom'

import { BlockchainVerifiedBanner } from '../blockchain-verified-banner'
import { IUnSdg, IScan, IImpactConsumerScanItem } from 'src/types'
import {
  Item,
  ItemBottom,
  ItemImage,
  ItemText,
  LinkSt,
  ItemTextWrapper,
} from './impact-cards-hor.styled'
import { Box } from '@mui/material'
import { AIGeneratedBanner } from '../ai-generated-banner'
import { AIVerifiedBanner } from '../ai-verified-banner'
import { WorldHeartIcon } from 'src/assets/icons/v2/WorldHeartIcon'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
interface IProps {
  title: string | number
  subtitle: string
  image: string
  unSdg: Array<IUnSdg>
  id: string
  quantityName: string
  scans: IScan[]
  primaryColor: string
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
  accountImage: string
  isImpactsPage: boolean
  aiGenerated: boolean
  aiVerifiedCount: number
  aiVerifiedInfo: IImpactConsumerScanItem[]
  templateId?: string
}

export const ImpactCard = ({
  templateId,
  image,
  title,
  subtitle,
  id,
  quantityName,
  scans,
  primaryColor,
  walletAddress,
  showWalletAddress,
  showBcInfo,
  accountImage,
  isImpactsPage,
  aiGenerated,
  aiVerifiedCount,
  aiVerifiedInfo,
}: IProps) => {
  const location = useLocation()

  const isEmpty = !image || image.trim().length === 0
  const isUiAvatar = image?.includes('ui-avatars.com/api')
  const showFallback = isEmpty || isUiAvatar
  const isFairtrade = templateId === JOURNEY_PAGE_TEMPLATE_ID.FAIRTRADE

  return (
    <Box
      id="impact-card-component__components-impacts-cards-hor__box__l60"
      sx={{ position: 'relative' }}
    >
      <Item
        id="impact-card-component__components-impacts-cards-hor__item__l61"
        disabled={!isImpactsPage}
      >
        <LinkSt
          id="impact-card-component__components-impacts-cards-hor__linkst__l62"
          style={{
            pointerEvents: isImpactsPage ? 'auto' : 'none',
            paddingTop: aiGenerated ? '20px' : '0px',
          }}
          to={`${location.pathname}/impacts#${id}`}
          isFairtrade={isFairtrade}
        >
          {/* <ItemImage style={{ backgroundImage: `url(${image})` }} /> */}
          <ItemImage
            id="impact-card-component__components-impacts-cards-hor__itemimage__l70"
            style={
              showFallback
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundImage: 'none',
                  }
                : { backgroundImage: `url(${image})` }
            }
          >
            {showFallback && <WorldHeartIcon size={80} color={'#666'} />}
          </ItemImage>
          <ItemBottom
            id="impact-card-component__components-impacts-cards-hor__itembottom__l84"
            isQuantity={!!title}
          >
            {title && (
              <ItemTextWrapper id="impact-card-component__components-impacts-cards-hor__itemtextwrapper__l86">
                <ItemText
                  id="impact-card-component__components-impacts-cards-hor__itemtext__l87"
                  variant="h4"
                >
                  {title}
                </ItemText>
                <ItemText
                  id="impact-card-component__components-impacts-cards-hor__itemtext__l88"
                  variant="h6"
                >
                  {quantityName}
                </ItemText>
              </ItemTextWrapper>
            )}
            <ItemText
              // sx={{ fontSize: '10px' }}
              id="impact-card-component__components-impacts-cards-hor__itemtext__l91"
              variant="body2"
            >
              {subtitle}
            </ItemText>
          </ItemBottom>
        </LinkSt>
      </Item>
      {showBcInfo && scans && scans.length > 0 && (
        <BlockchainVerifiedBanner
          size={40}
          scans={scans}
          stroke={primaryColor}
          walletAddress={walletAddress}
          showWalletAddress={showWalletAddress}
          impactImage={image}
          impactName={subtitle}
          accountImage={accountImage}
        />
      )}
      {aiGenerated && aiVerifiedCount > 0 && aiVerifiedInfo && (
        <AIVerifiedBanner aiVerifiedCount={aiVerifiedCount} data={aiVerifiedInfo} />
      )}
      {aiGenerated && <AIGeneratedBanner />}
    </Box>
  )
}
